const HighlightedItinerariesDataBuilder = (bestItinerariesData) => ({
  build() {
    return bestItinerariesData.reduce(
      (highlightedItinerariesData, itineraryData) => {
        const { itinerary } = itineraryData;
        const repeatedItineraryData = highlightedItinerariesData.find(
          ({ itinerary: highlightedItinerary }) => {
            return (
              highlightedItinerary && itinerary?.id === highlightedItinerary.id
            );
          }
        );
        if (itinerary && !repeatedItineraryData) {
          highlightedItinerariesData.push(itineraryData);
        }
        return highlightedItinerariesData;
      },
      []
    );
  },
});

export default HighlightedItinerariesDataBuilder;
